import { Box, VStack } from "@kazaar-platform/design-system";
import { useMemo } from "react";
import { useScrollDetectionV2 } from "../useScrollDetectionV2";
import { MAX_WIDTH } from "./usePageTemplate.constants";
import {
  type PageTemplateV2ContentProps,
  type PageTemplateV2HeaderProps,
  type PageTemplateV2Props,
} from "./usePageTemplate.types";

export const usePageTemplate = () => {
  const { isScrolled, ref } = useScrollDetectionV2();

  const PageTemplateV2 = useMemo(() => {
    const Base = ({ children, dataCy }: PageTemplateV2Props) => (
      <Box h="100%" w="100%" overflow="hidden" dataCy={dataCy}>
        {children}
      </Box>
    );

    const Header = ({ children }: PageTemplateV2HeaderProps) => (
      <VStack justify="center">{children}</VStack>
    );

    const Content = ({
      children,
      p,
      px,
      py,
      mb,
    }: PageTemplateV2ContentProps) => (
      <Box maxW="100%" mx="auto" overflow="auto" ref={ref}>
        <Box maxW={MAX_WIDTH} p={p} px={px} py={py} mb={mb}>
          {children}
        </Box>
      </Box>
    );

    Base.Header = Header;
    Base.Content = Content;

    return Base;
  }, [ref]);

  return {
    PageTemplateV2,
    isScrolled,
  };
};
